import '@trpc/server/observable';
export { s as splitLink } from '../splitLink-4c75f7be.mjs';
